import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0a1e91a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "huddles-card huddles-overview-stats" }
const _hoisted_2 = { class: "section section--top" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "panel" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { computed } from 'vue'
import { palette } from '@/utils/palette'
import HuddlesMetric from '@/mobile/src/views/appV4/huddles/HuddlesMetric.vue'
import { BaseGoals } from '@/entities/huddles'

interface Props {
    baseGoals: BaseGoals
    cxscoreAsPercentage: boolean
    cxmetric?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesOverviewStats',
  props: {
    baseGoals: {},
    cxscoreAsPercentage: { type: Boolean, default: false },
    cxmetric: { default: 'CSAT' }
  },
  setup(__props: any) {

const props = __props

const displayCxScore = (cxscore: number | undefined): string => {
    if (cxscore === undefined || cxscore === null) {
        return '-'
    }
    return `${cxscore}${props.cxscoreAsPercentage ? '%' : ''}`
}

const displayCxScoreGoalRange = computed(() => {
    return props.baseGoals.cxscore_goal_range
        ? 'Year ' + props.baseGoals.cxscore_goal_range
        : ''
})

const displaySalesDollarValue = (amount: number): string => {
    if (!amount) {
        return '-'
    }
    return `$${amount}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(HuddlesMetric, {
          "top-label": _ctx.cxmetric,
          "metric-value": displayCxScore(_ctx.baseGoals.cxscore),
          "value-color": _unref(palette).pGray900,
          "bottom-label": "Last 30 days"
        }, null, 8, ["top-label", "metric-value", "value-color"]),
        _createVNode(HuddlesMetric, {
          "top-label": `${_ctx.cxmetric} Goal`,
          "metric-value": displayCxScore(_ctx.baseGoals.cxscore_goal),
          "value-color": _unref(palette).successGreen,
          "bottom-label": displayCxScoreGoalRange.value
        }, null, 8, ["top-label", "metric-value", "value-color", "bottom-label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(HuddlesMetric, {
          "top-label": "Spend per head Goal",
          "metric-value": 
                        displaySalesDollarValue(_ctx.baseGoals.sales_per_head_goal)
                    ,
          "value-color": _unref(palette).successGreen
        }, null, 8, ["metric-value", "value-color"])
      ])
    ])
  ]))
}
}

})